<template lang='pug'>
  include ../Bemto
  +b.i-catalog.--variant_default
    slot(name="heading")
    catalog-sidebar(
      :filters="filters"
      @update:filters="changeFilters"
      :pagination="pagination",
      :attributesResource='attributesResource',
      :additionalResource="additionalResource"
      :label='label'
      :filterName="filterName"
      :needSearch="needSearch"
    )
    +e.content
      +b.i-preloader.--variant_1(:class="{'is-active': loading}")
        +e.item.--size_md
      slot
    ui-limit-pagination(
      :pagination='pagination'
      @input='handlePaginate'
    )
</template>

<script>

import CatalogSidebar from './Sidebar'

export default {
  components: {
    CatalogSidebar,
  },

  props: [
    'result',
    'loading',
    'receive',
    'parameters',
    'filters',
    'changeFilters',
    'pagination',
    'changePagination',
    'attributesResource',
    'label',
    'filterName',
    'needSearch',
    'additionalResource',
    'needAddBtns',
  ],

  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.receive(this.parameters)
    },

    handlePaginate({ limit: limitValue, offset }) {
      if (this.loading) {
        return
      }
      const limit = limitValue || this.pagination.limit
      this.changePagination({ limit, offset })
    },
  },
}

</script>
